export default __webpack_public_path__ + "static/media/g3-solar-bg.5e56d192.jpeg";